import React from 'react';
import { Link } from 'react-router-dom';

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Combined Hero and Reach Section with Background Image */}
      <div className="relative min-h-screen bg-cover bg-center bg-no-repeat" style={{backgroundImage: "url('/hero/hero 1.png')"}}>
        {/* Dark overlay for better text readability */}
        <div className="absolute inset-0 bg-blue-900 bg-opacity-80"></div>
        
        <div className="relative container mx-auto px-4 py-20">
          {/* About Us Content */}
          <div className="text-center text-white mb-16">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">About US</h1>
            <h2 className="text-3xl md:text-4xl font-bold mb-6">We Always Make The Best</h2>
            <p className="text-lg md:text-xl max-w-4xl mx-auto mb-8 leading-relaxed">
              Infinity Tech Africa is a licensed software development company in Kenya offering Bulk SMS, USSD, M-Pesa API integration, POS systems & custom telecom solutions.
              We are a licensed Content Service Provider (CSP) and Application Service Provider (ASP) accredited by the Communications Authority of Kenya, offering trusted and compliant digital services to businesses, enterprises, SMEs, SACCOs, schools, NGOs and government organisations across East Africa.
            </p>
            <p className="text-lg md:text-xl max-w-4xl mx-auto mb-8 leading-relaxed">
              Since 2016, Infinity Tech Africa has delivered end-to-end technology solutions, including Bulk SMS platforms, USSD applications, M-Pesa API integrations, stock and inventory management (POS) systems, school management systems, and customer survey & online voting solutions.
              Our team brings over 10 years of expertise in the telecommunications industry, having built multiple applications from the ground up. We understand unique user requirements and design custom software solutions that are reliable, scalable, and tailored to client needs.
            </p>
            <p className="text-lg md:text-xl max-w-4xl mx-auto mb-8 leading-relaxed">
              At Infinity Tech Africa, we are committed to innovation, customer experience, and digital transformation in Kenya and East Africa, helping businesses unlock efficiency and achieve growth through technology.
            </p>
            <Link
              to="/contact"
              className="relative bg-white text-blue-800 px-8 py-3.5 rounded-lg font-bold hover:bg-blue-50 transition-all duration-300 
                    shadow-[0_5px_15px_rgba(30,64,175,0.2)] hover:shadow-[0_10px_25px_rgba(30,64,175,0.3)] 
                    transform hover:-translate-y-1 active:translate-y-0.5 active:shadow-[0_3px_10px_rgba(30,64,175,0.2)]"
            >
              <span className="relative z-10">Contact Us</span>
              <span className="absolute inset-0 rounded-lg bg-blue-100 opacity-0 hover:opacity-20 transition-opacity duration-300"></span>
            </Link>
          </div>

          {/* Our Reach Section */}
          <div className="text-white pb-16 mb-16 border-b border-blue-200/30">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-4">
                OUR <span className="text-blue-200">REACH</span>
              </h2>
            </div>
            
            {/* Countries Grid - Full Width */}
            <div className="max-w-4xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                {/* Kenya */}
                <div className="text-center bg-white/5 p-6 rounded-lg hover:bg-white/10 transition-all">
                  <h3 className="text-2xl font-bold text-blue-200 mb-4">KENYA</h3>
                  <ul className="text-white space-y-2">
                    <li>• Safaricom</li>
                    <li>• Telkom</li>
                    <li>• Airtel</li>
                  </ul>
                </div>
                
                {/* Tanzania */}
                <div className="text-center bg-white/5 p-6 rounded-lg hover:bg-white/10 transition-all">
                  <h3 className="text-2xl font-bold text-blue-200 mb-4">TANZANIA</h3>
                  <ul className="text-white space-y-2">
                    <li>• Airtel</li>
                    <li>• Tigo</li>
                    <li>• Vodacom</li>
                  </ul>
                </div>
                
                {/* Uganda */}
                <div className="text-center bg-white/5 p-6 rounded-lg hover:bg-white/10 transition-all">
                  <h3 className="text-2xl font-bold text-blue-200 mb-4">UGANDA</h3>
                  <ul className="text-white space-y-2">
                    <li>• Airtel</li>
                    <li>• MTN</li>
                  </ul>
                </div>

                {/* Ghana */}
                <div className="text-center bg-white/5 p-6 rounded-lg hover:bg-white/10 transition-all">
                  <h3 className="text-2xl font-bold text-blue-200 mb-4">GHANA</h3>
                  <ul className="text-white space-y-2">
                    <li>• Telecel</li>
                    <li>• MTN</li>
                  </ul>
                </div>
                {/* Ghana */}
                <div className="text-center bg-white/5 p-6 rounded-lg hover:bg-white/10 transition-all">
                  <h3 className="text-2xl font-bold text-blue-200 mb-4">AUSTRALIA</h3>
                  <ul className="text-white space-y-2">
                    <li>• China Mobile</li>
                    
                  </ul>
                </div>
                {/* Ghana */}
                <div className="text-center bg-white/5 p-6 rounded-lg hover:bg-white/10 transition-all">
                  <h3 className="text-2xl font-bold text-blue-200 mb-4">UNITED KINGDOM</h3>
                  <ul className="text-white space-y-2">
                    <li>• China Mobile</li>
                    
                  </ul>
                </div>
                {/* Ghana */}
                <div className="text-center bg-white/5 p-6 rounded-lg hover:bg-white/10 transition-all">
                  <h3 className="text-2xl font-bold text-blue-200 mb-4">USA</h3>
                  <ul className="text-white space-y-2">
                    <li>• China Mobile</li>
                    
                  </ul>
                </div>
                {/* Ghana */}
                <div className="text-center bg-white/5 p-6 rounded-lg hover:bg-white/10 transition-all">
                  <h3 className="text-2xl font-bold text-blue-200 mb-4">INDIA</h3>
                  <ul className="text-white space-y-2">
                    <li>• China Mobile</li>
                    
                  </ul>
                </div>
                {/* Ghana */}
                <div className="text-center bg-white/5 p-6 rounded-lg hover:bg-white/10 transition-all">
                  <h3 className="text-2xl font-bold text-blue-200 mb-4">FRANCE</h3>
                  <ul className="text-white space-y-2">
                    <li>• China Mobile</li>
                    
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Awards Section */}
          <div className="text-white pt-16">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-4">
                OUR <span className="text-blue-200">AWARDS</span>
              </h2>
              <p className="text-blue-200/80 text-lg">Recognition of Excellence</p>
            </div>
            
            {/* Awards Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
              {/* MEA Business Award Card */}
              <div className="bg-white bg-opacity-90 border-2 border-blue-200 rounded-lg overflow-hidden shadow-md hover:shadow-xl hover:border-blue-400 transition-all duration-300 transform hover:scale-105">
                <div className="h-32 bg-white flex items-center justify-center">
                  <img 
                    src="/awards/mea-award.png" 
                    alt="MEA Business Award" 
                    className="h-full w-full object-contain p-2"
                    onError={(e) => {
                      e.target.onerror = null; 
                      e.target.src = "/awards/default-award.jpg";
                    }}
                  />
                </div>
                <div className="p-4">
                  <div className="text-xs text-blue-500 font-semibold mb-1">MEA Business Awards</div>
                  <div className="text-lg font-bold text-gray-800 mb-2">Innovation Excellence Award</div>
                  <div className="text-sm text-gray-600 mb-3">Digital Business Communications</div>
                  <div className="text-xs text-gray-500 border-t pt-2">2020 • SMS Africa</div>
                </div>
              </div>
              
              {/* DEAR Awards Card */}
              <div className="bg-white bg-opacity-90 border-2 border-blue-200 rounded-lg overflow-hidden shadow-md hover:shadow-xl hover:border-blue-400 transition-all duration-300 transform hover:scale-105">
                <div className="h-32 bg-white flex items-center justify-center">
                  <img 
                    src="/awards/dear-award.png" 
                    alt="DEAR Award" 
                    className="h-full w-full object-contain p-2"
                    onError={(e) => {
                      e.target.onerror = null; 
                      e.target.src = "/awards/default-award.jpg";
                    }}
                  />
                </div>
                <div className="p-4">
                  <div className="text-xs text-blue-500 font-semibold mb-1">DEAR AWARDS 2022</div>
                  <div className="text-lg font-bold text-gray-800 mb-2">Most Adaptive Use of Technology</div>
                  <div className="text-sm text-gray-600 mb-3">Runner Up • Infinity Tech Africa</div>
                  <div className="text-xs text-gray-500 border-t pt-2">27/06/2022 • UK Kenya Tech HUB</div>
                </div>
              </div>
              
              {/* Infinity Tech Award Card */}
              <div className="bg-white bg-opacity-90 border-2 border-blue-200 rounded-lg overflow-hidden shadow-md hover:shadow-xl hover:border-blue-400 transition-all duration-300 transform hover:scale-105">
                <div className="h-32 bg-white flex items-center justify-center">
                  <img 
                    src="/awards/infinity-award.png" 
                    alt="Infinity Tech Award" 
                    className="h-full w-full object-contain p-2"
                    onError={(e) => {
                      e.target.onerror = null; 
                      e.target.src = "/awards/default-award.jpg";
                    }}
                  />
                </div>
                <div className="p-4">
                  <div className="text-xs text-blue-500 font-semibold mb-1">MEA Business</div>
                  <div className="text-lg font-bold text-gray-800 mb-2">Innovation Excellence Award</div>
                  <div className="text-sm text-gray-600 mb-3">Digital Business Communications</div>
                  <div className="text-xs text-gray-500 border-t pt-2">Infinity Tech International Limited</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Team Section */}
      <div className="py-16 bg-gradient-to-r from-blue-900 via-blue-800 to-blue-600 text-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">
              Professional <span className="text-blue-200">TEAM</span>
            </h2>
            <p className="text-lg max-w-3xl mx-auto">
              We have a dedicated and experienced team of professionals who can provide 
              cutting-edge software solutions and seamless bulk SMS services to enhance your business.
            </p>
          </div>

          {/* Team Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {/* Team Member 1 */}
            <div className="text-center group transition-all duration-300"> 
              <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden border-4 border-white shadow-lg"> 
                <img 
                src="/team/Judy.png" 
                alt="Peter - CEO" 
                className="w-full h-full object-cover" 
                /> 
                </div> 
                <h3 className="font-bold text-lg mb-1">Nyaruai Muhoro</h3> 
                <p className="text-sm text-blue-200">Chief Operations Officer</p> 
            </div>

            {/* Team Member 2 */}
            <div className="text-center group transition-all duration-300"> 
              <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden border-4 border-white shadow-lg"> 
                <img src="/team/nelly.png" alt="Jade - Account Manager" className="w-full h-full object-cover" /> 
              </div> 
              <h3 className="font-bold text-lg mb-1">Praxidise Nelima</h3> 
              <p className="text-sm text-blue-200">Admin| Finance| HRM</p> 
            </div>

            {/* Team Member 3 */}
            <div className="text-center group transition-all duration-300"> 
              <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden border-4 border-white shadow-lg"> 
                <img src="/team/Maryann.png" alt="Alvin - Finance Manager" className="w-full h-full object-cover" /> 
              </div> 
              <h3 className="font-bold text-lg mb-1">Maryann Wanjiru</h3> 
              <p className="text-sm text-blue-200">Sales & Customer Relationship Manager</p> 
            </div>

            {/* Team Member 4 */}
            <div className="text-center group transition-all duration-300"> 
              <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden border-4 border-white shadow-lg"> 
                <img src="/team/Venic2.png" alt="Alpha - Senior Software Programmer" className="w-full h-full object-cover" /> 
              </div> 
              <h3 className="font-bold text-lg mb-1">Venic Seme</h3> 
              <p className="text-sm text-blue-200">Office & Facilities Administrator</p> 
            </div> 
          </div>

          {/* Second Row of Team Members */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-8"> 
            {/* Team Member 5 */} 
            <div className="text-center group transition-all duration-300"> 
              <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden border-4 border-white shadow-lg"> 
                <img src="/team/Mumbi.png" alt="Shylene - Software Developer" className="w-full h-full object-cover" /> 
              </div> 
              <h3 className="font-bold text-lg mb-1">Mumbi Kariuki</h3> 
              <p className="text-sm text-blue-200">Software Developer</p> 
            </div>

            {/* Team Member 6 */}
            <div className="text-center group transition-all duration-300"> 
              <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden border-4 border-white shadow-lg"> 
                <img src="/team/Schola.png" alt="Mary - Quality Assurance" className="w-full h-full object-cover" /> 
              </div> 
              <h3 className="font-bold text-lg mb-1">Scholastica Akinyi</h3> 
              <p className="text-sm text-blue-200">Software Developer</p> 
            </div>

            {/* Team Member 7 */}
            <div className="text-center group transition-all duration-300"> 
              <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden border-4 border-white shadow-lg"> 
                <img src="/team/Alex.png" alt="John - Systems Administrator" className="w-full h-full object-cover" /> 
              </div> 
              <h3 className="font-bold text-lg mb-1">Njoroge Macharia</h3> 
              <p className="text-sm text-blue-200">Software Developer</p> 
            </div>

            {/* Team Member 8 */}
            <div className="text-center group transition-all duration-300"> 
              <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden border-4 border-white shadow-lg"> 
                <img src="/team/Jack.png" alt="Sheila - Marketing Specialist" className="w-full h-full object-cover" /> 
              </div> 
              <h3 className="font-bold text-lg mb-1">Jack Karuno</h3> 
              <p className="text-sm text-blue-200">Technical Support Specialist</p> 
            </div>
          </div>
        </div>
      </div>

      {/* Clients Section with Slideshow */}
      <div className="py-16 bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              Our <span className="text-blue-600">CLIENTS</span>
            </h2>
          </div>

          {/* Clients Slideshow Container */}
          <div className="max-w-6xl mx-auto overflow-hidden" onMouseEnter={(e) => e.currentTarget.querySelector('.animate-slide').style.animationPlayState = 'paused'} onMouseLeave={(e) => e.currentTarget.querySelector('.animate-slide').style.animationPlayState = 'running'}>
            <div 
              className="flex gap-6 animate-slide"
              style={{
                width: 'calc(38 * (200px + 24px))', // 38 total clients (19 x 2 duplicates) * (width + gap)
              }}
            >
              {/* Duplicate the clients for seamless loop */}
              {[...Array(2)].map((_, setIndex) => (
                <React.Fragment key={setIndex}>
                  {/* Client 1 - Bayer */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/testimonials/test5.png" 
                      alt="Bayer" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 2 - Radio Africa Group */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/clients/radio africa logo2.png" 
                      alt="Radio Africa Group" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 3 - Acorn */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/clients/acorn logo.png" 
                      alt="Acorn" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 4 - My Credit */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/clients/my credit logo.png" 
                      alt="My Credit" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 5 - Meliora */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/testimonials/mel logo.png" 
                      alt="Meliora" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 6 - Interswitch */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/clients/switch logo2.png" 
                      alt="Interswitch" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 7 - ABC Bank */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/clients/abc logo.png" 
                      alt="ABC Bank" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 8 - CMI */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/clients/cmi logo.png" 
                      alt="CMI" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 9 - Arpu */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/clients/Arpu.png" 
                      alt="Arpu" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 10 - Vipingo */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/clients/Vipingo.png" 
                      alt="Vipingo" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 11 - Rupha */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/clients/Rupha.png" 
                      alt="Rupha" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 12 - Riverlong */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/clients/Riverlong.png" 
                      alt="RiverLong" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 13 - Kemri */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/clients/Kemri.png" 
                      alt=" Kemri" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 14 - Qwetu */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/clients/Qwetu.png" 
                      alt="Qwetu" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 15 - RunBeyond */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/clients/RunBeyond.png" 
                      alt="RunBeyond" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 16 - Cff */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/clients/Cff.png" 
                      alt="Cff" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 17 - Zed */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/clients/Zed.png" 
                      alt="Zed" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 18 - Tisini */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/clients/Tisini.png" 
                      alt="Tisini" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>

                  {/* Client 19 - Truvets */}
                  <div className="bg-white rounded-lg border-2 border-gray-200 p-6 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-48 h-24">
                    <img 
                      src="/clients/Truvets.png" 
                      alt="Truvets" 
                      className="max-w-full max-h-16 object-contain"
                    />
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Footer Section */}
      <footer className="bg-blue-600 text-white py-12">
          <div className="max-w-7xl mx-auto px-6">
            
            {/* Top 3 Columns */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 border-b border-blue-500 pb-10">
              
              {/* About Us */}
              <div className="space-y-3 md:border-r border-white md:pr-6">
                <h3 className="text-lg font-bold mb-2">About Us</h3>
                <ul className="text-sm space-y-2">
                  <li><a href="about" className="hover:text-blue-200">Who we are</a></li>
                  <li><a href="about" className="hover:text-blue-200">News Hub</a></li>
                  <li><a href="about" className="hover:text-blue-200">Our Reach</a></li>
                  
                </ul>
              </div>

              {/* Customer Service */}
              <div className="space-y-3 md:border-r border-white md:px-6">
                <h3 className="text-lg font-bold mb-2">Customer Service</h3>
                <ul className="text-sm space-y-2">
                  <li><a href="contact" className="hover:text-blue-200">Message Us</a></li>
                  
                  <li><a href="contact" className="hover:text-blue-200">Comment/Complaint</a></li>
                </ul>
              </div>

              {/* Join + Payment */}
              <div className="space-y-4 md:pl-6">
                
                <div>
                <h4 className="text-sm font-semibold mb-2">Payment Options</h4>
                <div className="flex space-x-4">
                  <img src="/icons/mpesa2.png" alt="Visa" className="h-12 object-contain" />
                  <img src="/icons/mastercard.png" alt="Mastercard" className="h-6 object-contain" />
                  <img src="/icons/visa.png" alt="Amex" className="h-6 object-contain" />
                </div>
              </div>
              </div>
            </div>

            {/* Contact Icons Section */}
            <div className="flex justify-center mt-8 mb-6">
              <div className="flex items-center space-x-6 bg-green-700 px-8 py-4 rounded-lg shadow-lg">
                <span className="text-sm font-semibold">Get in Touch:</span>
                <a 
                  href="tel:+254722943271" 
                  className="bg-white hover:bg-blue-100 p-3 rounded-full transition-all duration-300 transform hover:scale-110 shadow-md"
                  title="Call us"
                >
                  <svg className="w-6 h-6 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                  </svg>
                </a>
                <a 
                  href="https://wa.me/254722943271" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-white hover:bg-green-50 p-3 rounded-full transition-all duration-300 transform hover:scale-110 shadow-md"
                  title="WhatsApp us"
                >
                  <svg className="w-6 h-6 text-green-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                </a>
              </div>
            </div>

            {/* Social Media Section */}
            <div className="flex justify-center">
              <div className="flex space-x-4 border border-white p-3 rounded">
                <a href="https://www.facebook.com/SMSAfrica01?mibextid=wwXIfr&rdid=M64RTVM7l0SsUXbw&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1D45K1gBPv%2F%3Fmibextid%3DwwXIfr#" target="_blank" rel="noopener noreferrer"><img src="/icons/facebook.png" alt="Facebook" className="w-6 h-6" /></a>
                <a href="https://www.linkedin.com/company/infinity-tech-africa/" target="_blank" rel="noopener noreferrer"><img src="/icons/linkedin.png" alt="LinkedIn" className="w-6 h-6" /></a>
                <a href="https://www.instagram.com/smsafrica/profilecard/?igsh=eXgwOHBydWdlZGVi" target="_blank" rel="noopener noreferrer"><img src="/icons/email.png" alt="Email" className="w-6 h-6" /></a>
                <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer"><img src="/icons/x logo.png" alt="Twitter" className="w-6 h-6" /></a>
                <a href="https://www.tiktok.com/@infinitytechafrica?_t=ZM-8xr2bhp0ey0&_r=1" target="_blank" rel="noopener noreferrer"><img src="/icons/tiktok logo2.png" alt="YouTube" className="w-6 h-6" /></a>
              </div>
            </div>

            {/* Bottom Footer */}
            <div className="text-center pt-6 mt-6 border-t border-blue-500 text-sm">
              <p>
  &copy; 2025 Infinity Tech Africa |{' '}
  <a
    href="/privacy-policy.pdf"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:text-blue-200 underline"
  >
    Privacy Policy
  </a>{' '}
  | Terms & Conditions Apply
</p>
            </div>
          </div>
        </footer>

      <style jsx>{`
        @keyframes slide {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-slide {
          animation: slide 60s linear infinite;
        }
      `}</style>

    </div>
  );
};

export default AboutUs;